import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layout-2-col-xl",
  "use": "layout-2-col-xl-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"layout-2-col-xl\"><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 5h17c.5 0 1 .4 1 1v12c0 .5-.5 1-1 1H4c-.6 0-1-.5-1-1V6c0-.6.4-1 1-1Zm16 12V7h-2.5v10H20ZM5 17h10.5V7H5v10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol